// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionPlanBoardWidget_board__3cND8 {
  width: 100%;
}

.ActionPlanBoardWidget_state__xNLeu,
.ActionPlanBoardWidget_error__yvvIP {
  padding: 12px;
  border-radius: 8px;
  background: #fff;
}

.ActionPlanBoardWidget_error__yvvIP {
  color: #b42318;
}

.ActionPlanBoardWidget_columns__tx0P3 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  align-items: stretch;
}

.ActionPlanBoardWidget_column__6sKaX {
  min-height: 500px;
  display: flex;
  flex-direction: column;
  padding: 14px;
  border: 1px solid #e2e7eb;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.58);
}

.ActionPlanBoardWidget_highlighted__NfUDr {
  box-shadow: inset 0 0 0 2px rgba(21, 90, 168, 0.12);
}

.ActionPlanBoardWidget_columnHeader__omtGZ {
  display: grid;
  grid-template-columns: auto auto 1fr;
  align-items: center;
  gap: 9px;
  margin-bottom: 12px;
}

.ActionPlanBoardWidget_columnHeader__omtGZ h2 {
  margin: 0;
  color: #1c3445;
  font-size: 1rem;
  font-weight: 700;
}

.ActionPlanBoardWidget_count__hbJFy {
  justify-self: start;
  color: #98a3ad;
  font-size: 0.82rem;
  font-weight: 700;
}

.ActionPlanBoardWidget_columnIcon__V2eBz {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1rem;
  font-weight: 700;
}

.ActionPlanBoardWidget_need__ZrJI7 {
  background: #e8f5fb;
  color: #2797c7;
}

.ActionPlanBoardWidget_proposal__i4piK {
  background: #fff2e6;
  color: #ff8b43;
}

.ActionPlanBoardWidget_appointment__XlfLy {
  background: #e9f9ef;
  color: #2fac68;
}

.ActionPlanBoardWidget_items__2wNBh {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ActionPlanBoardWidget_empty__RQ-HN {
  margin: 12px 0;
  color: #87949e;
  font-size: 0.82rem;
  text-align: center;
}

.ActionPlanBoardWidget_columnAction__npLCO {
  margin-top: 12px;
}

.ActionPlanBoardWidget_itemCard__fC7yX,
.ActionPlanBoardWidget_appointmentCard__9rH7C {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  border: 1px solid #e2e7eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 3px 10px rgba(31, 54, 72, 0.05);
}

.ActionPlanBoardWidget_itemCard__fC7yX strong,
.ActionPlanBoardWidget_appointmentCard__9rH7C > strong {
  color: #152f40;
  font-size: 0.9rem;
  line-height: 1.35;
}

.ActionPlanBoardWidget_cardTopRow__9Ab1r {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.ActionPlanBoardWidget_valueBadge__L6O0E,
.ActionPlanBoardWidget_appointmentType__lqZwS,
.ActionPlanBoardWidget_status__T3imZ {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 0.7rem;
}

.ActionPlanBoardWidget_valueBadge__L6O0E[data-value="bienveillance"] {
  border: 1px solid var(--upcare-value-bienveillance);
  background: var(--upcare-value-bienveillance-soft);
  color: #8c6a00;
}

.ActionPlanBoardWidget_valueBadge__L6O0E[data-value="engagement"] {
  border: 1px solid var(--upcare-value-engagement);
  background: var(--upcare-value-engagement-soft);
  color: #17658f;
}

.ActionPlanBoardWidget_valueBadge__L6O0E[data-value="faire-equipe"] {
  border: 1px solid var(--upcare-value-faire-equipe);
  background: var(--upcare-value-faire-equipe-soft);
  color: #a20f4f;
}

.ActionPlanBoardWidget_valueBadge__L6O0E[data-value="respect"] {
  border: 1px solid var(--upcare-value-respect);
  background: var(--upcare-value-respect-soft);
  color: #1f7448;
}

.ActionPlanBoardWidget_appointmentType__lqZwS,
.ActionPlanBoardWidget_status__T3imZ {
  background: #f0f3f5;
  color: #667782;
}

.ActionPlanBoardWidget_themeBadge__biX8P {
  align-self: flex-start;
  padding: 4px 8px;
  border-radius: 999px;
  background: #eaf5f9;
  color: #245b72;
  font-size: 0.7rem;
  font-weight: 600;
}

.ActionPlanBoardWidget_requestOrganization__wSrgO {
  color: #667782;
  font-size: 0.76rem;
  font-weight: 600;
}

.ActionPlanBoardWidget_presenter__f5dXL {
  color: #687986;
  font-size: 0.78rem;
}

.ActionPlanBoardWidget_appointmentCard__9rH7C {
  cursor: pointer;
  border-top: 3px solid #8bb7ca;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.ActionPlanBoardWidget_appointmentCard__9rH7C[data-value="bienveillance"] {
  border-top-color: var(--upcare-value-bienveillance);
}

.ActionPlanBoardWidget_appointmentCard__9rH7C[data-value="engagement"] {
  border-top-color: var(--upcare-value-engagement);
}

.ActionPlanBoardWidget_appointmentCard__9rH7C[data-value="faire-equipe"] {
  border-top-color: var(--upcare-value-faire-equipe);
}

.ActionPlanBoardWidget_appointmentCard__9rH7C[data-value="respect"] {
  border-top-color: var(--upcare-value-respect);
}

.ActionPlanBoardWidget_appointmentCard__9rH7C:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(31, 54, 72, 0.09);
}

.ActionPlanBoardWidget_appointmentSummary__FIjSi {
  display: flex;
  gap: 10px;
  margin-top: 2px;
}

.ActionPlanBoardWidget_dateTile__wrQdI,
.ActionPlanBoardWidget_participantTile__mSys4 {
  min-width: 58px;
  min-height: 66px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
  border-radius: 8px;
}

.ActionPlanBoardWidget_dateTile__wrQdI {
  border: 1px solid #2f6b86;
  background: #fff;
  color: #174c67;
}

.ActionPlanBoardWidget_dateTile__wrQdI strong {
  font-size: 1.15rem;
  line-height: 1;
}

.ActionPlanBoardWidget_dateTile__wrQdI span,
.ActionPlanBoardWidget_dateTile__wrQdI small,
.ActionPlanBoardWidget_participantTile__mSys4 small {
  font-size: 0.65rem;
}

.ActionPlanBoardWidget_participantTile__mSys4 {
  background: #eef2f4;
  color: #315e73;
}

.ActionPlanBoardWidget_participantTile__mSys4 > span {
  font-size: 1.1rem;
}

.ActionPlanBoardWidget_participantTile__mSys4 strong {
  font-size: 0.95rem;
}

.ActionPlanBoardWidget_registerButton__U1-nN,
.ActionPlanBoardWidget_registered__5a8m1,
.ActionPlanBoardWidget_full__Qonz8 {
  width: 100%;
  min-height: 40px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 0.78rem;
  font-weight: 700;
}

.ActionPlanBoardWidget_registerButton__U1-nN {
  border: 0;
  background: #17677e;
  color: #fff;
  cursor: pointer;
}

.ActionPlanBoardWidget_registerButton__U1-nN:hover {
  background: #115469;
}

.ActionPlanBoardWidget_registered__5a8m1 {
  background: #def5e8;
  color: #1d7b4a;
}

.ActionPlanBoardWidget_full__Qonz8 {
  background: #edf0f2;
  color: #61717b;
}

@media (max-width: 1200px) {
  .ActionPlanBoardWidget_columns__tx0P3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .ActionPlanBoardWidget_column__6sKaX:last-child {
    grid-column: 1 / -1;
  }
}

@media (max-width: 760px) {
  .ActionPlanBoardWidget_columns__tx0P3 {
    grid-template-columns: 1fr;
  }

  .ActionPlanBoardWidget_column__6sKaX,
  .ActionPlanBoardWidget_column__6sKaX:last-child {
    min-height: auto;
    grid-column: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ActionPlan/ActionPlanBoardWidget.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mDAAmD;EACnD,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".board {\r\n  width: 100%;\r\n}\r\n\r\n.state,\r\n.error {\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n}\r\n\r\n.error {\r\n  color: #b42318;\r\n}\r\n\r\n.columns {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 16px;\r\n  align-items: stretch;\r\n}\r\n\r\n.column {\r\n  min-height: 500px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 14px;\r\n  border: 1px solid #e2e7eb;\r\n  border-radius: 14px;\r\n  background: rgba(255, 255, 255, 0.58);\r\n}\r\n\r\n.highlighted {\r\n  box-shadow: inset 0 0 0 2px rgba(21, 90, 168, 0.12);\r\n}\r\n\r\n.columnHeader {\r\n  display: grid;\r\n  grid-template-columns: auto auto 1fr;\r\n  align-items: center;\r\n  gap: 9px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.columnHeader h2 {\r\n  margin: 0;\r\n  color: #1c3445;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.count {\r\n  justify-self: start;\r\n  color: #98a3ad;\r\n  font-size: 0.82rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.columnIcon {\r\n  width: 30px;\r\n  height: 30px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.need {\r\n  background: #e8f5fb;\r\n  color: #2797c7;\r\n}\r\n\r\n.proposal {\r\n  background: #fff2e6;\r\n  color: #ff8b43;\r\n}\r\n\r\n.appointment {\r\n  background: #e9f9ef;\r\n  color: #2fac68;\r\n}\r\n\r\n.items {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.empty {\r\n  margin: 12px 0;\r\n  color: #87949e;\r\n  font-size: 0.82rem;\r\n  text-align: center;\r\n}\r\n\r\n.columnAction {\r\n  margin-top: 12px;\r\n}\r\n\r\n.itemCard,\r\n.appointmentCard {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 14px;\r\n  border: 1px solid #e2e7eb;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  box-shadow: 0 3px 10px rgba(31, 54, 72, 0.05);\r\n}\r\n\r\n.itemCard strong,\r\n.appointmentCard > strong {\r\n  color: #152f40;\r\n  font-size: 0.9rem;\r\n  line-height: 1.35;\r\n}\r\n\r\n.cardTopRow {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n\r\n.valueBadge,\r\n.appointmentType,\r\n.status {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  min-height: 24px;\r\n  padding: 3px 8px;\r\n  border-radius: 999px;\r\n  font-size: 0.7rem;\r\n}\r\n\r\n.valueBadge[data-value=\"bienveillance\"] {\r\n  border: 1px solid var(--upcare-value-bienveillance);\r\n  background: var(--upcare-value-bienveillance-soft);\r\n  color: #8c6a00;\r\n}\r\n\r\n.valueBadge[data-value=\"engagement\"] {\r\n  border: 1px solid var(--upcare-value-engagement);\r\n  background: var(--upcare-value-engagement-soft);\r\n  color: #17658f;\r\n}\r\n\r\n.valueBadge[data-value=\"faire-equipe\"] {\r\n  border: 1px solid var(--upcare-value-faire-equipe);\r\n  background: var(--upcare-value-faire-equipe-soft);\r\n  color: #a20f4f;\r\n}\r\n\r\n.valueBadge[data-value=\"respect\"] {\r\n  border: 1px solid var(--upcare-value-respect);\r\n  background: var(--upcare-value-respect-soft);\r\n  color: #1f7448;\r\n}\r\n\r\n.appointmentType,\r\n.status {\r\n  background: #f0f3f5;\r\n  color: #667782;\r\n}\r\n\r\n.themeBadge {\r\n  align-self: flex-start;\r\n  padding: 4px 8px;\r\n  border-radius: 999px;\r\n  background: #eaf5f9;\r\n  color: #245b72;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.requestOrganization {\r\n  color: #667782;\r\n  font-size: 0.76rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.presenter {\r\n  color: #687986;\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.appointmentCard {\r\n  cursor: pointer;\r\n  border-top: 3px solid #8bb7ca;\r\n  transition: transform 120ms ease, box-shadow 120ms ease;\r\n}\r\n\r\n.appointmentCard[data-value=\"bienveillance\"] {\r\n  border-top-color: var(--upcare-value-bienveillance);\r\n}\r\n\r\n.appointmentCard[data-value=\"engagement\"] {\r\n  border-top-color: var(--upcare-value-engagement);\r\n}\r\n\r\n.appointmentCard[data-value=\"faire-equipe\"] {\r\n  border-top-color: var(--upcare-value-faire-equipe);\r\n}\r\n\r\n.appointmentCard[data-value=\"respect\"] {\r\n  border-top-color: var(--upcare-value-respect);\r\n}\r\n\r\n.appointmentCard:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 6px 16px rgba(31, 54, 72, 0.09);\r\n}\r\n\r\n.appointmentSummary {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.dateTile,\r\n.participantTile {\r\n  min-width: 58px;\r\n  min-height: 66px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 6px 8px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.dateTile {\r\n  border: 1px solid #2f6b86;\r\n  background: #fff;\r\n  color: #174c67;\r\n}\r\n\r\n.dateTile strong {\r\n  font-size: 1.15rem;\r\n  line-height: 1;\r\n}\r\n\r\n.dateTile span,\r\n.dateTile small,\r\n.participantTile small {\r\n  font-size: 0.65rem;\r\n}\r\n\r\n.participantTile {\r\n  background: #eef2f4;\r\n  color: #315e73;\r\n}\r\n\r\n.participantTile > span {\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.participantTile strong {\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.registerButton,\r\n.registered,\r\n.full {\r\n  width: 100%;\r\n  min-height: 40px;\r\n  margin-top: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 8px;\r\n  font-size: 0.78rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.registerButton {\r\n  border: 0;\r\n  background: #17677e;\r\n  color: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n.registerButton:hover {\r\n  background: #115469;\r\n}\r\n\r\n.registered {\r\n  background: #def5e8;\r\n  color: #1d7b4a;\r\n}\r\n\r\n.full {\r\n  background: #edf0f2;\r\n  color: #61717b;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .columns {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n\r\n  .column:last-child {\r\n    grid-column: 1 / -1;\r\n  }\r\n}\r\n\r\n@media (max-width: 760px) {\r\n  .columns {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .column,\r\n  .column:last-child {\r\n    min-height: auto;\r\n    grid-column: auto;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"board": `ActionPlanBoardWidget_board__3cND8`,
	"state": `ActionPlanBoardWidget_state__xNLeu`,
	"error": `ActionPlanBoardWidget_error__yvvIP`,
	"columns": `ActionPlanBoardWidget_columns__tx0P3`,
	"column": `ActionPlanBoardWidget_column__6sKaX`,
	"highlighted": `ActionPlanBoardWidget_highlighted__NfUDr`,
	"columnHeader": `ActionPlanBoardWidget_columnHeader__omtGZ`,
	"count": `ActionPlanBoardWidget_count__hbJFy`,
	"columnIcon": `ActionPlanBoardWidget_columnIcon__V2eBz`,
	"need": `ActionPlanBoardWidget_need__ZrJI7`,
	"proposal": `ActionPlanBoardWidget_proposal__i4piK`,
	"appointment": `ActionPlanBoardWidget_appointment__XlfLy`,
	"items": `ActionPlanBoardWidget_items__2wNBh`,
	"empty": `ActionPlanBoardWidget_empty__RQ-HN`,
	"columnAction": `ActionPlanBoardWidget_columnAction__npLCO`,
	"itemCard": `ActionPlanBoardWidget_itemCard__fC7yX`,
	"appointmentCard": `ActionPlanBoardWidget_appointmentCard__9rH7C`,
	"cardTopRow": `ActionPlanBoardWidget_cardTopRow__9Ab1r`,
	"valueBadge": `ActionPlanBoardWidget_valueBadge__L6O0E`,
	"appointmentType": `ActionPlanBoardWidget_appointmentType__lqZwS`,
	"status": `ActionPlanBoardWidget_status__T3imZ`,
	"themeBadge": `ActionPlanBoardWidget_themeBadge__biX8P`,
	"requestOrganization": `ActionPlanBoardWidget_requestOrganization__wSrgO`,
	"presenter": `ActionPlanBoardWidget_presenter__f5dXL`,
	"appointmentSummary": `ActionPlanBoardWidget_appointmentSummary__FIjSi`,
	"dateTile": `ActionPlanBoardWidget_dateTile__wrQdI`,
	"participantTile": `ActionPlanBoardWidget_participantTile__mSys4`,
	"registerButton": `ActionPlanBoardWidget_registerButton__U1-nN`,
	"registered": `ActionPlanBoardWidget_registered__5a8m1`,
	"full": `ActionPlanBoardWidget_full__Qonz8`
};
export default ___CSS_LOADER_EXPORT___;
